// @flow

import styled from "styled-components";

// Helpers
import spacingExtender from "./spacingExtender";

const Button = styled.button`
  ${({ secondary, theme, xxlarge, xlarge, large, medium, tiny, disabled }) => {
  const { disabledColor, primaryColor, secondaryColor, primaryBackgroundColor, secondaryBackgroundColor, shadow, fontFamily, fontWeight } = theme.button;

  let styles = {};
  styles.color = primaryColor;
  styles.backgroundColor = primaryBackgroundColor;

  if (secondary) {
    styles.color = secondaryColor;
    styles.backgroundColor = secondaryBackgroundColor;
  }

  if (disabled) {
    styles.cursor = "not-allowed !important";
    styles.backgroundColor = disabledColor;
  }

  styles.paddingTop = "14px";
  styles.paddingBottom = "14px";

  if (xxlarge) {
    styles.paddingRight = "115px";
    styles.paddingLeft = "115px";
    styles.width = "100%";
  } else if (xlarge) {
    styles.paddingRight = "135px";
    styles.paddingLeft = "135px";
  } else if (large) {
    styles.paddingRight = "45px";
    styles.paddingLeft = "45px";
    styles.minWidth = "150px";
  } else if (medium) {
    styles.paddingTop = "5px";
    styles.paddingBottom = "5px";
    styles.paddingRight = "25px";
    styles.paddingLeft = "25px";
    styles.minWidth = "100px";
  } else if (tiny) {
    styles.paddingTop = "0px";
    styles.paddingBottom = "0px";
    styles.paddingLeft = "5px";
    styles.paddingRight = "5px";
  } else {
    styles.paddingRight = "25px";
    styles.paddingLeft = "25px";
  }

  styles.boxShadow = shadow;
  styles.fontFamily = fontFamily;
  styles.fontWeight = fontWeight;
  return styles;
}}
  display: inline-block;
  font-size: 14px;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  user-select: none;
  border: 1px solid transparent;
  border-radius: 5px;
  outline: none;
  ${spacingExtender}
  &:focus {
    ${({ theme, disabled, secondary }) => {
  const { selectedShadow, primarySelectedColor } = theme.button;
  if (disabled) {
    return {};
  }
  if (secondary) {
    return { boxShadow: selectedShadow };
  }
  return { boxShadow: selectedShadow, color: primarySelectedColor };
}}};
  &:hover {
    ${({ theme, disabled, secondary }) => {
  const { selectedShadow, primarySelectedColor } = theme.button;
  if (disabled) {
    return {};
  }
  if (secondary) {
    return { boxShadow: selectedShadow };
  }
  return { boxShadow: selectedShadow, color: primarySelectedColor };
}}};
`;

export default Button;



// WEBPACK FOOTER //
// ./src/common/button.js